// extracted by mini-css-extract-plugin
export default {"changeLanguage":"RPxn89_kGlxUaqL6G39a","languageSelected":"kcRvjk4uPZDQR4BqtaX8"};